import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'

import { IMG } from '../../themes'
import { SelectStyle } from './style'
import { cutString2, COMPONENT_TEXT } from '../../helpers'

const defaultFunction = () => { }
export class SearchAndSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentValue: props.keyword
    }
    this.divSearch = 0
  }

  componentDidMount () {
    this.updateCheckInIconLeft()
  }

  componentDidUpdate () {
    if (this.props.keyword !== this.state.currentValue && !this.timer) {
      this.setState({ currentValue: this.props.keyword })
    }
    this.updateCheckInIconLeft()
  }

  updateCheckInIconLeft () {
    const input = this.containerNode && this.containerNode.childNodes[0]
    if (!this.props.showCheckInIcon || !input) return

    const style = window.getComputedStyle(input)
    this.measureContext = this.measureContext || document.createElement('canvas').getContext('2d')
    this.measureContext.font = `${style.fontSize} ${style.fontFamily}`
    const textWidth = this.measureContext.measureText(this.state.currentValue || '').width
    const left = Math.round(Math.min(
      input.offsetLeft + parseFloat(style.paddingLeft) + textWidth + 4,
      input.offsetLeft + input.offsetWidth
    ))

    if (left !== this.state.checkInIconLeft) {
      this.setState({ checkInIconLeft: left })
    }
  }

  displayList = () => {
    const {
      list,
      onClickList,
      empty,
      language = 'EN',
      isRoom
    } = this.props

    if (list.length === 0 && this.containerNode.childNodes[0] === document.activeElement && !empty) {
      return (
        <div
          className={`list-search empty`}
        >
          {COMPONENT_TEXT.NO_SEARCH[language]}
        </div>
      )
    }
    return list.map((data, index) => {
      let color = ''
      let more = false
      if (data.statusRoom === 2) {
        color = 'red'
      } else if (data.statusRoom === 1) {
        color = 'yellow'
      }
      else {
        color = ''
      }
      if (data.type === 3 && data.isUsed === 1) {
        color = 'grey'
      }
      if (data.more) {
        more = true
      }

      return (
        <div key={`${index}-list-search`}
          className={!data.disable ? `list-search pointer ${color}` : `list-search-dis pointer`}
          onMouseDown={!data.disable
            ? (color !== 'grey'
              ? (more !== true ? () => onClickList(data) : defaultFunction)
              : defaultFunction)
            : defaultFunction}
        >
          {isRoom
            ? (
              <div className='list'>
                <span className='list-search-label'>
                  {cutString2(data.name, 20)}
                  {Boolean(data.checkInRequired) && <span className='checkin-icon' aria-label='require check-in' />}
                </span>
                <div className={data.isAvailable ? 'circle-available' : 'circle-busy'} />
              </div>
            )
            : cutString2(data.name, 20)
          }
        </div>
      )
    })
  }

  focus () {
    this.containerNode.childNodes[0].focus()
    this.setState({ show: true })
    if (this.props.select) {
      this.props.select()
    }
  }

  handleChange = (event) => {
    const text = {
      target: {
        value: event.target.value
      }
    }
    const _text = text.target.value
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = undefined
    }
    this.setState({ currentValue: _text })
    this.timer = setTimeout(() => { this.timer = undefined; this.props.onChangeSearch(text) }, 200)
  }

  render () {
    const {
      keyword,
      className = '',
      classInput = '',
      clearSearch,
      list,
      placeholder,
      icon,
      select,
      type,
      disabled,
      onFocus,
      onBlur,
      empty,
      showList,
      typeIcon,
      colorTheme,
      isOpenDropdown,
      showCheckInIcon,
    } = this.props
    const {
      currentValue
    } = this.state
    return (
      <SelectStyle
        colorTheme={colorTheme}
        isNotFound={isEmpty(list)}
        disabled={disabled ? 'not-allowed' : ''}
      >
        <div
          className={`div-search-select ${className}${disabled ? ' disabled' : ''}`}
          onClick={(e) => this.focus(e)}
          style={{pointerEvents: disabled ? 'none' : 'auto'}}
          ref={(ref) => this.containerNode = ref} >
          <input
            value={currentValue}
            onChange={this.handleChange}
            type={type ? type : 'text'}
            placeholder={placeholder}
            className={typeIcon === 'autosuggest' ? 'input-search-dropdown' : `input-search ${classInput}`}
            disabled={disabled}
            onFocus={() => {
              if (onFocus && !empty) onFocus()
            }}
            onBlur={() => onBlur()}
          />
          {showCheckInIcon && currentValue && this.state.checkInIconLeft !== undefined && (
            <span
              className='checkin-icon field-checkin-icon'
              style={{ left: this.state.checkInIconLeft }}
              aria-label='require check-in'
            />
          )}
          {!disabled && (keyword !== '' ?
            <img
              className={typeIcon === 'autosuggest' ? 'icon-cancel-dropdown' : 'icon-cancel'}
              src={IMG[`ic_cancel_text.svg`]}
              alt='ic_cancel_text'
              onClick={!disabled ? clearSearch : () => { }}
            />
            :
            <img
              className={
                typeIcon === 'autosuggest' ?
                  'icon-search-dropdown'
                  : select ? 'icon-select' : 'icon-sort'
              }
              src={IMG[icon ? icon : `sort.svg`]}
              alt={icon ? icon : 'sort'}
              onClick={showList}
            />
          )}
        </div>
        
        {isOpenDropdown && 
         <div className='div-select-list'
              style={{
               width: '100%',
               boxSizing: 'border-box',
               height: 'auto',
               maxHeight: '240px',
               zIndex: '2'
             }}
           >
             {this.displayList()}
           </div>
        }
      </SelectStyle>
    )
  }
}

SearchAndSelect.defaultProps = {
  onBlur: () => { },
}

SearchAndSelect.propTypes = {
  onBlur: PropTypes.func,
}
